// extracted by mini-css-extract-plugin
export default {"badge":"badge___FXEhXgL2","badge--outline":"badge--outline___RVu3mDBJ","badge--shadow":"badge--shadow___GtmD0Vml"};